import type { CalendarEvent } from 'owa-calendar-types';
import getRecurrenceStrings from 'owa-recurrence-utils/lib/getRecurrenceStrings';
import { END_DATE_RECURRENCE } from 'owa-recurrence-types';

export function getRecurrenceSummary(event: CalendarEvent) {
    const recurrence = event.Recurrence;

    if (recurrence) {
        const isRecurrenceEndDateSet = recurrence.RecurrenceRange.__type == END_DATE_RECURRENCE;
        let { recurrenceString, ariaLabel } = getRecurrenceStrings(
            event.Start.tz,
            event,
            event.Recurrence
        );
        return isRecurrenceEndDateSet ? ariaLabel : recurrenceString;
    }

    return null;
}
